import { INDUSTRIES, type AssessmentStatus } from '@cyberscore/contracts';

export const STATUS_LABEL: Record<AssessmentStatus, string> = {
  in_progress: 'In progress',
  submitted: 'Submitted',
  in_review: 'In review',
  in_remediation: 'Changes requested',
  decided: 'Decided',
  closed: 'Closed',
};

export const STATUS_TONE: Record<AssessmentStatus, 'neutral' | 'ok' | 'warn'> = {
  in_progress: 'neutral',
  submitted: 'ok',
  in_review: 'ok',
  in_remediation: 'warn',
  decided: 'ok',
  closed: 'neutral',
};

export const industryLabel = (k: string | null) =>
  (k && (INDUSTRIES as Record<string, string>)[k]) ?? k ?? '—';
